import React, { Component, PropTypes } from 'react'
import './style.less'

class Hero extends Component {
	constructor(props) {
		super(props)
		this.state = {
			intervalId: null,
			backgroundIndex: 0
		}
	}

	componentDidMount() {
		const { interval, images } = this.props

		this.setState(() => {
			return {
				intervalId: setInterval((state) => {
					this.setState((state) => {
						const { backgroundIndex } = state
						return {
							backgroundIndex: (backgroundIndex + 1) % images.length
						}
					}, )
				}, interval)
			}
		})
	}

	componentWillUnmount() {
		const { intervalId } = this.state
		clearInterval(intervalId)
	}

	render() {
		const { backgroundIndex } = this.state
		const { headline, children, images, className } = this.props
		// const style = {
		// 	backgroundImage: `url(${images[backgroundIndex]})`
		// }

		const imageElements = images.map((url, index) => {
			return <img src={url} key={url} className={index === backgroundIndex ? 'active' : 'inactive'} />
		})

	  return (
	    <div className={`hero ${className}`}>
				{imageElements}
	      <div className="container" >
	        <div className="row center-xs">
	          <div className="col-xs-12">
	            { headline && <h1>{headline}</h1> }
	            <div>
	              { children }
	            </div>
	          </div>
	        </div>
	      </div>
	    </div>
	  )
	}
}

Hero.propTypes = {
  headline: PropTypes.string,
  children: PropTypes.object,
	interval: PropTypes.number,
	images: PropTypes.array.isRequired,
	className: PropTypes.string
}

Hero.defaultProps = {
  headline: null,
  children: {},
	interval: 20000,
	className: ''
}

export default Hero



// WEBPACK FOOTER //
// ../components/Hero/index.js